import { render } from "./UpdateStatus.vue?vue&type=template&id=bb8234d6&scoped=true"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"

import "./UpdateStatus.vue?vue&type=style&index=0&id=bb8234d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8234d6"]])

export default __exports__